var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 19.8 18.8",
    style: {
      enableBackground: "new 0 0 19.8 18.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{fill:none;stroke:#000000;stroke-linecap:round;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-306.326 -232.814)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(306.326 232.814)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 8.1,
    cy: 8.1,
    r: 8.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 8.1,
    cy: 8.1,
    r: 7.6
  })), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 320.6,
    y1: 246.1,
    x2: 325.4,
    y2: 250.9
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.aa8e3c2fa6e97e36f2fada0f2fed44c0.svg";
export { ForwardRef as ReactComponent };